<!-- eslint-disable -->
<template>
	<div :class="['v-datepicker', { filled: filled, active: active }]">
		<date-picker
			v-model:value="val"
			@open="active = true"
			@close="active = false"
			:lang="langString"
			:disabled="disabled"
			value-type="format"
			format="YYYY-MM-DD"
		/>
		<label :for="htmlId">{{ label }}</label>
	</div>
</template>

<script>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/locale/pl';

export default {
	data() {
		return {
			val: '',
			langString: 'pl',
			active: false,
			filled: false,
		};
	},
	props: {
		htmlId: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	components: {
		DatePicker,
	},
	methods: {
		isFilled() {
			if (this.val) this.filled = true;
			else this.filled = false;
		},
	},
	mounted() {
		if (this.value) {
			this.val = new Date(this.value).toISOString();
		}
		this.isFilled();
	},
	updated() {
		this.isFilled();
	},
	watch: {
		val(newVal) {
			let mutationName = 'set' + this.htmlId;
			this.$store.commit(mutationName, newVal);
			this.$emit('updated', newVal);
		},
	},
};
</script>
<style>
.mx-datepicker {
	width: 100% !important;
}
</style>
